import { Button as HeroButton, extendVariants } from "@heroui/react";

export const CtaButton = extendVariants(HeroButton, {
  variants: {
    size: {},
  },
  defaultVariants: {
    color: "primary",
  },
  compoundVariants: [
    {
      class: "text-white",
    },
  ],
});
